import React from 'react';
import { withAuthorization } from '../session';
import NotFound from '../useful/NotFound';
import TournamentList from '../TournamentList/TournamentList';
import PremiumUser from '../admin/PremiumUser/PremiumUser';

const HomePage = (props) => {

  const currentUser = props.firebase.auth.currentUser;

  let homeComponent = <NotFound />
  if (currentUser && currentUser.token) {
    if (currentUser.token.admin) {
      homeComponent = <PremiumUser />
    } else if (currentUser.token.premium) {
      homeComponent = <TournamentList />
    }
  }

  return homeComponent;
}

// const condition = authUser => !!authUser;
const condition = authUser => {
  if (!!authUser) {
    return authUser.token.admin === true || authUser.token.premium === true;
  } else
    return false;
};
export default withAuthorization(condition)(HomePage);